module.exports = "pegasus_template/assets/themecapture1/simple/105.png";